// /**
//  * Warwhouse - Add
//  */

// React
import React, {useState, useEffect} from 'react';

// UI
import theme from '../../../theme';
import {makeStyles, Theme, createStyles} from '@material-ui/core/styles';
import {
  Grid,
  Button,
  DialogContent,
  IconButton,
  DialogActions,
  Dialog,
  Typography,
  Divider,
} from '@material-ui/core';
import jMoment from 'moment-jalaali';

// Icon
import Icon from '@mdi/react';
import {mdiClose} from '@mdi/js';

// Client SDK
import PackageManagementRepository from 'client-sdk/src/Repository/packagesManagement-repository';
import handleError from '../../../utils/handleError';
import handleNotfication from '../../../utils/handleNotification';

jMoment.loadPersian({dialect: 'persian-modern', usePersianDigits: true});

type Props = {
  onClose: () => void;
  updateList: () => void;
  isOpen: boolean;
  id: number;
  type: string;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.success.main,
      },
    },
    cancelTitle: {
      fontWeight: 500,
      textAlign: 'center',
      lineHeight: 2,
      marginTop: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
  })
);

function Cancel(props: Props) {
  const classes = useStyles();

  const disablePackage = async () => {
    const payload = {description: '', status: 'DISABLED'};
    try {
      await PackageManagementRepository.updateStatus({
        payload,
        id: props.id,
      });
      props.updateList();
      handleNotfication('بسته بندی با موفقیت غیرفعال شد', 'success');
      props.onClose();
    } catch (err) {
      handleError(err.response);
    }
  };

  const activePackage = async () => {
    const payload = {description: '', status: 'ACTIVE'};
    try {
      await PackageManagementRepository.updateStatus({
        payload,
        id: props.id,
      });
      props.updateList();
      handleNotfication('بسته بندی با موفقیت فعال شد', 'success');
      props.onClose();
    } catch (err) {
      handleError(err.response);
    }
  };

  return (
    <>
      <Dialog
        open={props.isOpen}
        fullWidth
        onClose={props.onClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {props.onClose ? (
              <IconButton aria-label="close" onClick={props.onClose}>
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <Typography variant="h6" className={classes.cancelTitle}>
            {`از ${
              props.type === 'CANCEL_DIALOG' ? 'غیرفعال' : 'فعال'
            } کردن بسته بندی با شناسه ${props.id} اطمینان دارید؟`}
          </Typography>
        </DialogContent>
        <Divider />
        <DialogActions>
          <Grid container spacing={2} justifyContent="flex-end">
            <Grid item xs={2}>
              <Button
                fullWidth
                autoFocus
                onClick={props.onClose}
                variant="outlined"
                size="large"
              >
                {'انصراف'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={
                  props.type === 'CANCEL_DIALOG'
                    ? disablePackage
                    : activePackage
                }
                size="large"
              >
                {`${props.type === 'CANCEL_DIALOG' ? 'غیرفعال' : 'فعال'}`}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </>
  );
}
export default Cancel;
